export default function TextQuestion({ data }) {
  return (
    <label>
      {data.title}
      <input type={data.type} name={data.name} className="border-2 block" />
    </label>
  );
}
